import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'

import { useFormatDuration } from '@root/shared'
import { dateByMinuteAtom } from '@root/shared/lib'

import { CurrencyBannerFooter } from './currency-banner-footer'

import type { PremiumMetaModel } from '@root/entities/premium'

type Props = {
  premium: PremiumMetaModel
}

export const CurrentPremiumBannerFooter = ({ premium }: Props) => {
  const { formatDuration } = useFormatDuration()
  const [expiresAt] = useAtom(premium.expiresAt)
  const [owner] = useAtom(premium.owner)
  const [now] = useAtom(dateByMinuteAtom)
  const [status] = useAtom(premium.status)

  const premiumTimeLeft = useMemo(
    () =>
      formatDuration({
        startAt: now,
        endAt: expiresAt,
        mode: 'singleUnitShort',
      }),
    [now, expiresAt, formatDuration],
  )

  return (
    <CurrencyBannerFooter
      status={status}
      owner={owner}
      premiumTimeLeft={premiumTimeLeft}
      slotResetButton={undefined}
    />
  )
}
